import { render, staticRenderFns } from "./You.vue?vue&type=template&id=ce6fec70&"
import script from "./You.vue?vue&type=script&lang=js&"
export * from "./You.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports